import { ErrorInfo } from 'react'

declare global {
  interface Window {
    newrelic?: {
      noticeError: (
        error: Error,
        customAttributes?: Record<string, unknown>
      ) => void
    }
  }
}

export const reportErrorDetails = (error: Error, errorInfo?: ErrorInfo) => {
  if (
    typeof window !== 'undefined' &&
    window.newrelic &&
    typeof window.newrelic.noticeError === 'function'
  ) {
    window.newrelic.noticeError(error, {
      componentStack: errorInfo?.componentStack,
    })
  }
}
